import { cn } from '@/lib/utils';

interface AvatarProps {
  src: string | null | undefined;
  alt?: string;
  size?: number;
  className?: string;
}

// Lightweight avatar. Shows the image if loaded, otherwise a deterministic
// gradient placeholder so we don't have a flash of broken img.
export function Avatar({ src, alt = '', size = 32, className }: AvatarProps) {
  return (
    <div
      className={cn('flex-shrink-0 rounded-full overflow-hidden bg-bg-elevated', className)}
      style={{ width: size, height: size, backgroundImage: src ? undefined : 'linear-gradient(135deg, #FF7A3D 0%, #7A39A8 100%)' }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          width={size}
          height={size}
          className="h-full w-full object-cover"
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
      ) : null}
    </div>
  );
}
